<template>
  <div>
    <el-dialog title="打印证书" :visible.sync="printModal" width="90%" center>
      <div>
        <div class="print-btn" @click="printCert">打印</div>
      </div>
      <vue-easy-print table-show ref="easyPrint">
        <div id="printArea" ref="printArea" name='printArea'>
          <!-- 分页 -->
          <div v-for="(v,k) in imgArr" :key="k">
            <img style="width:880px; height: 642px;" class="img" :src="v" />
          </div>
        </div>
      </vue-easy-print>

    </el-dialog>
  </div>
</template>


<script>
import vueEasyPrint from "vue-easy-print";
export default {
  name: "Print",
  components: {
    vueEasyPrint,
  },
  // 制作打印模版组件时，props区域尽量保留。
  props: {
    // 每页多少行
    onePageRow: {
      type: Number,
      default: 10
    },
    // 是否插入空白行
    blankLines: {
      type: Boolean,
      default: true
    },
    // 复制打印页面前调用的钩子
    beforeCopy: Function,
    // 打印页面前调用的钩子
    beforePrint: Function,
    getChineseNumber: Function // 求数字的中文写法，从easyPrint组件传入
  },
  data () {
    return {
      printData: [],
      imgArr: [],
      singleImg: '',
      printModal: false,
    };
  },
  methods: {

    show (printArr) {
      this.printData = printArr
      console.log(this.printData)
      this.imgArr = []
      this.printData.forEach((v, k) => {
        if (v.studentlist.length > 0 && v.subjecturl) {
          v.studentlist.forEach(e => {
            e.certBack = v.subjecturl
            this.fnDraw(e)
          })
        }
      })
      setTimeout(() => {
        console.log(this.imgArr)
      }, 3000);
    },
    test () {
      console.log(this.beforeCopy)
    },
    loadPng (src, callback) {
      let avatar = src
      let img = new Image()
      img.crossOrigin = '*'
      img.src = avatar
      img.onload = () => {
        callback && callback(img)
      }
    },
    fnDraw (obj) {
      const that = this
      console.log(obj, 'fnDraw')
      const oC = document.createElement('canvas')
      const gd = oC.getContext('2d')
      oC.width = 880
      oC.height = 642
      // 绘制背景图
      this.loadPng(obj.certBack, certBack => {
        gd.drawImage(
          certBack, 0, 0, 880, 642
        )
        // 绘制标题
        gd.font = 'normal normal 400 24px SourceHanSerifCN'
        gd.fillStyle = '#1D2225'
        gd.textAlign = 'left'
        gd.fillText(obj.name, 210, 355)
        gd.fillText(obj.card, 210, 395)
        gd.fillText(obj.name, 210, 435)
        gd.fillText(obj.name, 210, 475)
        gd.fillText(obj.name, 210, 515)
        gd.fillText(obj.name, 210, 555)
        const oUrl = oC.toDataURL('image/jpeg', 1)
        const oImg = new Image()
        oImg.src = oUrl
        oImg.onload = function () {
          that.singleImg = oImg.src
          that.imgArr.push(oImg.src)
          console.log(that.imgArr)
          that.printModal = true
        }
      })
    },
    printCert () {
      this.$refs.easyPrint.print();
    },
  },
  created () {
    console.log(this.printData)
  }
};
</script>

<style scoped>
.print-btn {
  padding: 15px 35px;
  background: #66b1ff;
  border: none;
  color: white;
  display: inline-block;
  border-radius: 5px;
}
@page {
  size: auto A4 landscape;
  margin: 3mm;
}
* {
  padding: 0;
  margin: 0;
}

.tab_company_out {
  page-break-after: always;
}
</style>



// WEBPACK FOOTER //
// src/components/testSystem/components/print.vue